import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  total: 0,
  error: "",
  message: "",
};

export const userAttemptedSurveyAction = createAsyncThunk(
  "user-attempted-survey",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `/admins/api/user/attempted/survey?p_user_id=${data?.p_user_id}&startDate=${data?.startDate}&endDate=${data?.endDate}&publisher_id=${data?.publisher_id}&partner_id=${data?.partner_id}&page=${data?.page}&limit=${data?.limit}`
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userAttemptedSurveySlice = createSlice({
  name: "user-attmpted-survey",
  initialState,
  reducers: {
    resetData: (state) => {
      state.status = null;
      state.loading = false;
      state.data = [];
      state.total = 0;
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userAttemptedSurveyAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userAttemptedSurveyAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.total = action?.payload?.total;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(userAttemptedSurveyAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetData } = userAttemptedSurveySlice.actions;

export const userAttemptedSurveyReducer = userAttemptedSurveySlice.reducer;
